const arrWorks = [
  {
    id: 'project-0',
    order: 4,
    highlight: false,
    name: 'Journey Cash',
    name2: 'Get Ready to Budget Like a Pro!',
    ShortDescrip: "Effortlessly manage group finances with this powerful web app. Perfect for travel with friends,"+
              " splitting bills, or coordinating group events, JourneyCash simplifies expense tracking and settlements.",
    LongDescrip: 'JOURNEY CASH is a simple yet powerful expense tracking web application designed to help you manage your group finances effortlessly. ' +
                "Whether you're traveling with friends, splitting bills with roommates, or organizing a group event, " +
                "JourneyCash makes it easy to track expenses and settle udp.",
    featureImage: 'card2-img.webp',
    featureImage2: 'snapshoot-project2.webp',
    alternateTextImage: 'Budget app project image.',
    technologies: ['Rails','Ruby','Postgres','CSS', 'HTML', 'JavaScript'],
    liveVersion: 'https://journeycash.onrender.com/',
    source: 'https://github.com/jicamargo/journeycash',
  },
  {
    id: 'project-1',
    name: 'That Sound',
    name2: 'Unleash Sound Innovation!',
    ShortDescrip: "Your ultimate sound library app, crafted with React and Redux. It's where innovation meets collaboration, offering dynamic user interfaces.",
    LongDescrip: "thatSound – a cutting-edge sound library application built using React and Redux. This repository serves as the central hub for collaborative development and innovation, where the power of React's dynamic user interfaces and Redux's state management combine to create an unparalleled user experience.",
    featureImage: 'card4-img.webp',
    featureImage2: 'snapshoot-project4.webp',
    alternateTextImage: 'secondary project ShortDescrip image.',
    technologies: ['React-JS', 'Redux', 'API','CSS', 'HTML', 'JavaScript'],
    liveVersion: 'https://thatsound.netlify.app/',
    source: 'https://github.com/jicamargo/thatSound',
  },
  {
    id: 'project-3',
    name: 'M M W',
    name2: 'Miami Music Festival',
    ShortDescrip: 'Engaging and visually captivating landing page dedicated to showcasing and promoting a vibrant Music Festival experience in Miami.',
    LongDescrip: 'The Miami Music Weekend (MMW) project is a responsive webpage that provides an all-inclusive platform for music enthusiasts. The webpage showcases a comprehensive '
                + 'list of events, including concerts, parties, and workshops, allowing users to explore and plan their itinerary. Additionally, it highlights special speakers invited '
                + 'to the festival, offering unique insights and discussions on the music industry. ',
    featureImage: 'card1-img.webp',
    featureImage2: 'snapshoot-project1.webp',
    alternateTextImage: 'Miami Music Weekend project image.',
    technologies: ['CSS', 'HTML', 'JavaScript', 'SaSS', 'Bootstrap'],
    liveVersion: 'https://jicamargo.github.io/mmw/',
    source: 'https://github.com/jicamargo/mmw',
  },
  {
    id: 'project-4',
    name: 'Space Travelers',
    name2: 'Space Exploration',
    ShortDescrip: "Explore the Universe with Space-X-React-Group. Discover the latest Space-X launches, rockets, and missions.",
    LongDescrip: "A Space-X-React-Group app built with React, Redux, CSS, and HTML. Users can view information about the latest Space-X launches, rockets, and missions. The app also features a search function, allowing users to search for information about specific launches, rockets, or missions.",
    featureImage: 'card5-img.webp',
    featureImage2: 'snapshoot-project5.webp',
    alternateTextImage: 'secondary project ShortDescrip image.',
    technologies: ['React','Redux','CSS', 'HTML'],
    liveVersion: 'https://space-travelers-five.vercel.app/',
    source: 'https://github.com/jicamargo/space-travelers',
  },
  {
    id: 'project-5',
    name: 'Top 10 Movies',
    name2: 'Best Movies of All Time!',
    ShortDescrip: "Explore a curated list of the best movies. Choose 5, 10 or 20 Top Movies. Switch between Dark/Light mode.",
    LongDescrip: 'Explore a curated list of the best movies. Choose 5, 10 or 20 Top Movies. Switch between Dark/Light mode.' +
         'Top 10 Movies is a platform designed for movie enthusiasts to discover, discuss, and share their thoughts on the top-rated films of all time.',
    featureImage: 'card8-img.webp',
    featureImage2: 'snapshoot-project8.webp',
    alternateTextImage: 'Top 10 Movies project image.',
    technologies: ['React', 'API', 'HTML', 'CSS', 'JavaScript', 'Jest', 'Webpack','Git Flow'],
    liveVersion: 'https://jicamargo.github.io/js-capstone/dist/',
    source: 'https://github.com/jicamargo/js-capstone',
  },
  {
    id: 'project-10',
    order: 3,
    highlight: true,
    name: 'Coffee And Cake',
    name2: 'Cafe Bar Showcase Site',
    ShortDescrip: "Cafe Bar Showcase Site built with JavaScript, SASS, CSS. This is a delightful web application built using vanilla JavaScript.",
    LongDescrip: "This app is designed to provide information about a coffee shop and bakery, allowing users to explore various sections of the business." +
    "This project showcases various interactive features, including mobile menus, slides, parallax effects, and a lightbox gallery.",
    featureImage: 'cardA-img.webp',
    featureImage2: 'snapshoot-projectA.webp',
    alternateTextImage: 'Coffee and Cake project image.',
    technologies: ['JavaScript', 'HTML', 'CSS', 'LESS'],
    liveVersion: 'https://jicamargo.github.io/coffee-and-cake/',
    source: 'https://github.com/jicamargo/coffee-and-cake/',
  },
  {
    id: 'project-10',
    name: 'Real Time Search',
    name2: 'Save, Search, Analyze – Your Queries, Your Insights',
    ShortDescrip: 'Explore a concise online search project, highlighting an optimized algorithm for efficient searches, smart database storage to avoid word repetitions, and intuitive analytics for enhanced insights.',
    LongDescrip: 'This application was Built with Ruby on Rails, using postgreSQL, the project aims to redefine how users interact with search functionality. ' 
    + 'The application dynamically updates search results as users type, providing instant feedback and Analytics',
    featureImage: 'search.webp',
    featureImage2: 'search.webp',
    alternateTextImage: 'Real time search project image.',
    technologies: ['Ruby on Rails', 'CSS', 'javascript', 'Stimulus', 'PostgreSQL'],
    liveVersion: 'https://realtimesearch-njvo.onrender.com/',
    source: 'https://github.com/jicamargo/real_time_search',
  },
  {
    id: 'project-11',
    order: 2,
    highlight: true,
    name: 'Depot - Store',
    name2: 'Where Customer Experience Meets Owner Control!',
    ShortDescrip: 'Ruby on Rails magic in action! Stimulus, Mailer, Turbo, and Hotwire. Real-time updates. Streamlined processes, robust support, and security layers elevate your business.',
    LongDescrip: 'Depot: An E-commerce Marvel. Elevate your shopping experience with Depot, a Ruby on Rails-powered e-commerce app. Seamlessly blending simplicity with efficiency,' +
    'Depot offers customers a user-friendly platform and empowers business owners with streamlined processes, robust support, valuable insights, and security layers. ' +
    'Experience innovation at every click with features like Stimulus for frontend interactivity, Mailer for order communication, TurboFrames and TurboStreams for dynamic carts,'+
    'and real-time product updates through Hotwire and Action Cable. ',
    featureImage: 'depot.webp',
    featureImage2: 'depot.webp',
    alternateTextImage: 'Depot project image.',
    technologies: ['Ruby on Rails', 'Tailwind CSS', 'javascript', 'Stimulus', 'Hotwire', 'TurboFrames', 'PostgreSQL'],
    liveVersion: 'http://www.jorgecamargo.live/',
    source: 'https://github.com/jicamargo/depot',
  },
  {
    id: "project-12",
    order: 1,
    highlight: true,
    name: "FestiPlanner - Concert Management",
    name2: "Streamline Your Concert Planning with Ease!",
    ShortDescrip: "Ultimate concert management with Ruby on Rails and React. Real-time updates, seamless scheduling, and robust ticketing support. Your events, perfectly organized. ",
    LongDescrip: "FestiPlanner: Revolutionize your concert planning. With a powerful blend of Ruby on Rails and React, FestiPlanner offers a seamless experience for managing concerts. " +
    "Enjoyfeatures like real-time updates, in-place editing with Hotwire, and dynamic ticket management. Whether you're scheduling events or tracking ticket sales, FestiPlanner provides the tools "+
    "you need for success. Key features include intuitive seat selection, secure user authentication, and an admin dashboard for comprehensive event oversight.",
    featureImage: "festiplanner.webp",
    featureImage2: "festiplanner.webp",
    alternateTextImage: "Concert management project image.",
    technologies: ["Ruby on Rails", "React", "Tailwind CSS", "Hotwire", "TurboStreams", "PostgreSQL"],
    liveVersion: "http://festiplanner.jorgecamargo.live/",
    source: "https://github.com/jicamargo/festiplanner_p"
  }
];

export default arrWorks;